import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NonConformanceList from "./conformance/List";
import NonConformanceCreate from "./conformance/Create";
import NonConformanceDetail from "./conformance/Detail";

const defaultFields = {
  Subject: { visible: false, label: '', required: false },
  Details: { visible: false, label: '', required: false },
  Type: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
  const fields = { ...defaultFields };

  fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
  fields.Details = { visible: true, label: languageFile["CONTRACT.WF.CONFORMANCE.FIELD.NOTIFICATION"], required: true };

  const workflowItem = workflowsQA[wfid];
  let clauses = workflowItem.clauses;

  fields.Type.clauses = clauses;

  return fields;
}

class NonConformanceRouter extends Component {
  constructor(props) {
    super(props);
    this.notificationType = "NC";
    this.documentType = 'DocumentNC';
    this.notifyingParty = props.workflowItem.notifyingParty;

    this.notificationName = props.workflowItem.notificationName;
    this.abbreviation = props.workflowItem.abbreviation;
  }
  shouldComponentUpdate() {
    return false;
  }
  render() {
    const { workflowItem } = this.props;

    return (
      <Routes caseSensitive>
        <Route
          path={workflowItem.config.paths.list}
          exact
          element={
            <NonConformanceList
              {...this.props}
              title={this.notificationName}
              abbreviation={this.abbreviation}
              notificationType={this.notificationType}
            />
          }
        />
          <Route
            path={workflowItem.config.paths.create}
            exact
            element={
                workflowItem.userFilters.mainNotice.createAllowed ? (
                    <NonConformanceCreate
                      {...this.props}
                      title={this.notificationName}
                      notificationType={this.notificationType}
                    />) : (
                    <Navigate replace to={workflowItem.paths.defaultPath} />
                )
            }
        />
        <Route
          path={'/:notificationid/*'}
          exact
          element={
            <NonConformanceDetail
              {...this.props}
              title={this.notificationName}
              abbreviation={this.abbreviation}
              documentType={this.documentType}
              notificationType={this.notificationType}
              notifyUserFilter={workflowItem.notifyUserFilter}
            />
          }
        />

      </Routes>
    );
  }
}



export default (NonConformanceRouter);
